import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const SubjectLevelTable = (props) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [tutorData, setTutorData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTutorData = async () => {
            try {
                const res = await axios.get(
                    `https://api.nadwa-uae.com/api/v2/tutor/${id || props.tutorId}/`
                );
                setTutorData(res.data);
            } catch (error) {
                setError("Failed to fetch tutor data. Please try again later.");
            }
        };

        fetchTutorData();
    }, [id, props.tutorId]);

    if (error) {
        return <p className="text-red-500">{error}</p>;
    }

    if (!tutorData) {
        return <p className="text-gray-500">Loading...</p>;
    }

    const { subjects } = tutorData;

    const groupedSubjects = subjects.reduce((acc, item) => {
        const { subject_name, level_name } = item;
        if (!acc[subject_name]) {
            acc[subject_name] = [];
        }
        acc[subject_name].push(level_name);
        return acc;
    }, {});

    const groupedSubjectArray = Object.entries(groupedSubjects).map(
        ([subject, levels]) => ({
            subject,
            levels: levels.join(", ")
        })
    );

    return (
        <div className="px-10 py-10 space-y-8 hidden sm:block">
            {/* Academic Qualifications Section */}
            <div>
                <h2 className="text-2xl font-bold">{"Subjects"}</h2>
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-50">
                                <th className="border-2 border-gray-400 p-3 text-center font-medium">
                                    S.No
                                </th>
                                <th className="border-2 border-gray-400 p-3 text-left font-medium">
                                    Subject
                                </th>
                                <th className="border-2 border-gray-400 p-3 text-left font-medium">
                                    Levels
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupedSubjectArray.map((item, index) => (
                                <tr key={index}>
                                    <td className="border-2 border-gray-400 text-center p-3">
                                        {index + 1}
                                    </td>
                                    <td className="border-2 border-gray-400 p-3">
                                        {item.subject}
                                    </td>
                                    <td className="border-2 border-gray-400 p-3">
                                        {item.levels}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default SubjectLevelTable;
